import { Route } from '@angular/router';
import { authGuard } from '@routes/guards/auth.guard';
import { guard } from '@routes/guards/guard-factory';

export const organizationsRoutes: Route[] = [
    {
        path: 'organizations',
        title: 'PRSS | Список организаций',
        loadComponent: () =>
            import('@pages/guids/organization/organization.component').then(
                (c) => c.OrganizationComponent,
            ),
        canActivate: [authGuard, guard('watch_refs_organizations')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Организаторы', url: null },
            ],
            reuse: true,
            searchString: true,
        },
    },
    {
        path: 'organizations/create',
        loadComponent: () =>
            import('@pages/guids/organization/create-organization/create-organization.component').then(
                (c) => c.CreateOrganizationComponent,
            ),
        // canActivate: [guardOrganizationWatch],
        canActivate: [authGuard, guard('watch_refs_organizations')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Создание организатора', url: null },
            ],
            searchString: false,
        },
    },
    {
        path: 'organizations/:id',
        loadComponent: () =>
            import('@pages/guids/organization/organization-details/organization-details.component').then(
                (c) => c.OrganizationDetailsComponent,
            ),
        // canActivate: [guardOrganizationWatch],
        canActivate: [authGuard],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Организаторы', url: '/organizations/' },
            ],
            searchString: false,
        },
    },
];
